import React from 'react';
import { ResponsiveSwarmPlot } from '@nivo/swarmplot';
import { calcColor } from "../../../common/services";
// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.



const generatePerceptionComment = (percent) => {
    if (percent > 0 && percent <= 20) {
        return "Extremely Urgent Attention Needed";
    } else if (percent > 20 && percent <= 40) {
        return "Urgent Attention Needed";
    } else if (percent > 40 && percent <= 60) {
        return "Moderate Attention Needed";
    } else if (percent > 60 && percent <= 80) {
        return "Low Attention Needed";
    } else {
        return "No Attention Needed";
    }
}

const calcSize = (entries) => {
    if(entries < 300) {
        return 15;
    }else if( entries > 300 && entries <= 1000) {
        return 10;
    } else if (entries > 1000 && entries <= 1500) {
        return 8;
    } else {
        return 6;
    }
}
const SwarmPlot = (props) => (
    <ResponsiveSwarmPlot
        data={props.data}
        groups={props.groups}
        value="perceptionLevel"
        valueFormat=".2f"
        valueScale={{ type: 'linear', min: 0, max: 100, reverse: false }}
        size={calcSize(props.entries)}
        spacing={6}
        colors={(point) => calcColor(point.data.perceptionLevel)}
        forceStrength={4}
        simulationIterations={100}
        borderColor={{
            from: 'color',
            modifiers: [
                [
                    'darker',
                    0.6
                ],
                [
                    'opacity',
                    0.5
                ]
            ]
        }}
        margin={{ top: 80, right: 100, bottom: 100, left: 100 }}
        axisBottom={{
            orient: 'bottom',
            tickSize: 10,
            tickPadding: 5,
            tickRotation: -30,
            legend: 'Assessments',
            legendPosition: 'middle',
            legendOffset: 60,
        }}
        axisLeft={null}
        axisRight={null}
        motionStiffness={50}
        motionDamping={10}
        theme={{
            axis: {
                fontSize: '14px',
                tickColor: '#eee',
                
                ticks: {
                    line: {
                        stroke: "gray"
                    },
                    text: {
                        fill: "#ffffff",
                    },
                },
                legend: {
                    text: {
                        fill: "#ffffff",
                        fontFamily: "Roboto Condensed",
                        fontWeight: 'normal',
                        fontSize: '15px'
                    }
                }
            },
        }}
        onClick={(node, e) => props.onNodeItemClick(node.data)}
        tooltip={(point) => (
            <div style={{
                padding: '8px',
                backgroundColor: calcColor(point.node.data.perceptionLevel),
                color: '#000',
                borderRadius: '5px',
                width: "320px",
                height: "120px",
                font: 'italic normal 18px Roboto Condensed'
            }}>
                <span><strong>Assessment: </strong>{point.node.data.group}</span><br />
                <span><strong>Student: </strong>{point.node.data.studentName}</span><br />
                <span><strong>Perception Level: </strong>{generatePerceptionComment(point.node.data.perceptionLevel)}</span>
            </div>
        )}
    />
)

export default SwarmPlot;


// WEBPACK FOOTER //
// ./src/components/DataViz/SwarmPlot/SwarmPlot.jsx